import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useDispatch, useSelector, useSaga } from '@grandvisionhq/state';
import { isDefined } from '@grandvisionhq/utils';
import { ConfiguratorContextProvider } from '../../Context/ConfiguratorContext.js';
import { PrivateSteppingContextProvider } from '../../Context/PrivateSteppingContext.js';
import { startConfigurator, nextStep, previousStep } from '../../state/actions.js';
import { configuratorFactory } from '../../state/sagas.js';
import { isFooterOpen, hasAttemptedNextStep, isLastStep } from '../../state/selectors.js';
import { getStepsList } from '../../state/selectors.internal.js';
import { Configurator } from './Configurator.js';

const useStepHandlers = (id)=>{
    const dispatch = useDispatch();
    const goToNextStep = React.useCallback((e)=>{
        e === null || e === void 0 ? void 0 : e.preventDefault();
        dispatch(nextStep({
            id
        }));
    }, [
        dispatch,
        id
    ]);
    const goToPreviousStep = React.useCallback((e)=>{
        e === null || e === void 0 ? void 0 : e.preventDefault();
        dispatch(previousStep({
            id
        }));
    }, [
        dispatch,
        id
    ]);
    return {
        goToPreviousStep,
        goToNextStep
    };
};
const ConfiguratorContainer = (_param)=>{
    var { id , stepsMap , stepSequence , onFinish , lastStepCTALabelKey , footerExpanderContent , footerTopBarContent , hideExpanderOnLastStep , onModalClose , onTriggerDataLayer  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "id",
        "stepsMap",
        "stepSequence",
        "onFinish",
        "lastStepCTALabelKey",
        "footerExpanderContent",
        "footerTopBarContent",
        "hideExpanderOnLastStep",
        "onModalClose",
        "onTriggerDataLayer"
    ]);
    var ref;
    const dispatch = useDispatch();
    // For the header
    const steps = useSelector((s)=>getStepsList(s, {
            id,
            stepsMap,
            stepSequence
        })
    );
    const currentStepName = (ref = steps.find((s)=>s.isCurrent
    )) === null || ref === void 0 ? void 0 : ref.name;
    const isFooterOpen$1 = useSelector((s)=>isFooterOpen(s, {
            id
        })
    );
    const hasAttemptedNextStep$1 = useSelector((s)=>hasAttemptedNextStep(s, {
            id
        })
    );
    const { rootSaga  } = React.useMemo(()=>configuratorFactory(id)
    , [
        id
    ]);
    const task = useSaga(rootSaga, {
        onStart (t) {
            t.setContext({
                [id]: {
                    stepsMap,
                    stepSequence,
                    onFinish
                }
            });
            dispatch(startConfigurator({
                id,
                stepSequence,
                stepsMap
            }));
        }
    }, [
        dispatch
    ]);
    React.useEffect(()=>{
        task === null || task === void 0 ? void 0 : task.setContext({
            [id]: {
                stepsMap,
                stepSequence,
                onFinish
            }
        });
    }, [
        task,
        stepsMap,
        stepSequence,
        onFinish,
        id
    ]);
    const { goToNextStep , goToPreviousStep  } = useStepHandlers(id);
    const isOnLastStep = useSelector((s)=>isLastStep(s, {
            id,
            stepsMap,
            stepSequence
        })
    );
    if (!isDefined(currentStepName)) {
        return null;
    }
    const contextValues = {
        configuratorId: id,
        hasAttemptedNextStep: hasAttemptedNextStep$1,
        isFooterOpen: isFooterOpen$1,
        goToNextStep,
        goToPreviousStep,
        onFinish,
        onModalClose,
        onTriggerDataLayer,
        isOnLastStep
    };
    return /*#__PURE__*/ React.createElement(PrivateSteppingContextProvider, {
        configuratorId: id,
        stepsMap: stepsMap,
        stepSequence: stepSequence,
        lastStepCTALabelKey: lastStepCTALabelKey,
        footerTopBarContent: footerTopBarContent,
        footerExpanderContent: footerExpanderContent,
        hideExpanderOnLastStep: hideExpanderOnLastStep
    }, /*#__PURE__*/ React.createElement(ConfiguratorContextProvider, swcHelpers.extends({}, contextValues), /*#__PURE__*/ React.createElement(Configurator, swcHelpers.extends({}, rest))));
};

export { ConfiguratorContainer };
//# sourceMappingURL=ConfiguratorContainer.js.map
